var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabTrIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4448 5.8125H7.88116C8.15528 5.12695 8.58903 4.5293 9.13729 4.0582L11.4448 5.8125ZM10.1366 3.41484C10.7057 3.14766 11.3338 3 12 3C13.8634 3 15.4596 4.16367 16.1189 5.8125H13.2943L10.1366 3.41484ZM12 12C9.54674 12 7.55845 9.98555 7.55845 7.5C7.55845 7.31016 7.56886 7.12031 7.59315 6.9375H16.4069C16.4312 7.12031 16.4416 7.31016 16.4416 7.5C16.4416 9.98555 14.4533 12 12 12ZM15.47 13.9828C15.8066 14.0918 16.1327 14.2289 16.4416 14.3941V21H11.3164L13.4747 17.3508L15.47 13.9828ZM14.3249 13.7297L12.6836 16.5H10.3344C8.8007 16.5 7.55845 17.7586 7.55845 19.3125C7.55845 19.9453 7.76665 20.5289 8.11364 21H5.25786C4.68879 21 4.22728 20.5324 4.22728 19.9559C4.22728 16.493 6.99631 13.6875 10.4142 13.6875H13.5858C13.8356 13.6875 14.082 13.7016 14.3249 13.7332V13.7297ZM19.7727 19.9559C19.7727 20.5324 19.3112 21 18.7422 21H17.552V15.143C18.9087 16.2926 19.7727 18.0223 19.7727 19.9559Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabTrIco);
export default __webpack_public_path__ + "static/media/Tab_tr_ico.ba402af5bb7648b1418d5c52a7ab255d.svg";
export { ForwardRef as ReactComponent };